import type { MultiStepFormStep } from '#/components/Form/MultiStepForm/MultiStepFormTypes';

export function getFieldsToValidateByStep(
  steps: MultiStepFormStep[],
  index: number,
): string[][] {
  return steps
    .filter((step, i) => i <= index)
    .map((step) =>
      step.sections.flatMap((section) =>
        section.rows
          .flatMap((row) => (!row ? [] : (row.fieldsToValidate ?? row.fields)))
          .filter(Boolean),
      ),
    );
}
